/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import photo1 from "assets/images/saintvalentin-1.jpg";

import mariage1 from "assets/images/mariage-1.jpg";

import tenue1 from "assets/images/tenue-1.jpg";

import robemariage1 from "assets/images/robemariage-1.jpg";

import sonorisation1 from "assets/images/sonorisation-1.jpg";

import logistique1 from "assets/images/logistique-1.jpg";

export default [
  {
    title: "Saint Valentin",
    description: "L'Art de la Célébration au Cœur de la Saint-Valentin 2025",
    items: [
      {
        image: photo1,
        route: "/RealisationSaintValentin",
      },
    ],
  },
  {
    title: "Mariage",
    description: "L'Art de Célébrer l'Amour : Nos Plus Belles Créations",
    items: [
      {
        image: mariage1,
        route: "/RealisationMariage",
      },
    ],
  },
  {
    title: "Tenue de soirée et traditionnelle",
    description: "L'Art de la Tradition au Service de Votre Élégance",
    items: [
      {
        image: tenue1,
        route: "/RealisationTenue",
      },
    ],
  },
  {
    title: "Robe de mariage",
    description: "L'Art de Célébrer l'Amour en Robe d'Exception",
    items: [
      {
        image: robemariage1,
        route: "/RealisationRobeMariage",
      },
    ],
  },
  {
    title: "Sonorisation conférence et évènementiel",
    description: "L'Excellence Sonore au Cœur de Vos Évènements",
    items: [
      {
        image: sonorisation1,
        route: "/RealisationSonorisation",
      },
    ],
  },
  {
    title: "Location logistique et évènementiel",
    description: "Une Logistique Sur-Mesure pour des Événements Réussis",
    items: [
      {
        image: logistique1,
        route: "/RealisationLogistique",
      },
    ],
  },
];
